module.exports = __webpack_public_path__ + "img/vending.e0f5efd7.svg";